<template>
  <div class="qa-list">
    <!-- <div class="normal-title">全部回答</div> -->
    <titleImg
      :icon="require('images/qa/questions/answer-title.png')"
      class="normal-title"
    />
    <VanListWrapper
      :apiFn="getQaAnswerList"
      :apiConfig="apiConfig"
      :pageKey="'pageNo'"
      :sizeKey="'pageSize'"
      emptyDescription="暂无回答~"
      :handleResponseData="handleResponseData"
      :beforeLoaded="true"
      :dataList="dataList"
      ref="listWrapper"
    >
      <template v-slot="slots">
        <div
          v-for="(item, index) in slots.array"
          :key="item.baseContentVo.objectId"
          class="item-outer"
          :class="{ last: slots.array.length - 1 === index }"
        >
          <answerItem
            v-if="+item.baseContentVo.objectType === 3"
            class="answer-item-outer"
            :class="{ 'is-server': $isServer }"
            :qaInfo="item"
            :showQaTitle="false"
            :showLevelName="false"
            :userDisplyType="2"
            userLevelIcon="bigIcon"
            bigIcon="bigIcon"
            errUrl="https://sdata.xinli001.com/t/5s"
            :channelFlag="channelFlag"
            @goAnswerDes="item => $emit('goAnswerDes', item)"
            @toUserHome="item => $emit('answerToUserHome', item)"
            @likeFinish="item => $emit('answerLikeFinish', item)"
            @followFinish="onFollowFinish"
            @reportFinish="item => $emit('answerReportFinish', item)"
            @shareSuccess="() => $emit('shareSuccess')"
          ></answerItem>
          <!-- 广告位 -->
          <flowAd v-else :adInfo="adInfo"></flowAd>
          <div class="gray-line" v-if="index !== slots.array.length - 1"></div>
        </div>
      </template>
    </VanListWrapper>
  </div>
</template>

<script>
import answerItem from 'component/platform/mutualHelp/v3/answerItem.vue'
import flowAd from 'component/qa/questions/flowAd.vue'
import VanListWrapper from 'component/platform/vanListWrapper.vue'
import { getQaAnswerList } from 'api/qa/questions.js'
import titleImg from 'component/qa/title.vue'

export default {
  components: {
    VanListWrapper,
    flowAd,
    answerItem,
    titleImg
  },
  props: {
    questionId: Number,
    dataList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      channelFlag: 'Platform_content_QA'
    }
  },
  computed: {
    apiConfig() {
      return {
        id: this.questionId
      }
    },
    adInfo() {
      const { adInfo } = this.$store.state.qaQuestionDetail
      if (adInfo !== null) {
        return {
          ...adInfo,
          baseContentVo: {
            objectType: -99,
            objectId: -99
          }
        }
      } else {
        return null
      }
    },
    answerList() {
      return this.$store.state.qaQuestionDetail.answerList || []
    }
  },
  watch: {
    adInfo() {
      this.insertAd()
    }
  },
  methods: {
    // 外部有调用
    refreshAnswerList() {
      this.$refs.listWrapper.refreshList()
    },
    getQaAnswerList,
    onFollowFinish(item) {
      this.$emit('answerFollowFinish', item)
      // 关注A以后，当前列表中A都要变成已关注
      const arr = [...this.answerList]
      arr.forEach(v => {
        if (v.baseUserInfoVo.userId == item.baseUserInfoVo.userId) {
          v.baseUserInfoVo.subscribeStatus = true
        }
      })
      this.$store.commit('qaQuestionDetail/setAnswerList', arr)
    },
    insertAd() {
      this.$refs.listWrapper.updateList(list => {
        let res = []
        if (list.length >= 3) {
          res = [...list.slice(0, 2), this.adInfo, ...list.slice(2)]
        } else if (list.length > 0) {
          res = [...list, this.adInfo]
        }
        return res.filter(item => !!item)
      })
    },
    handleResponseData(data = {}, page) {
      const list = Array.isArray(data) ? data : []
      this.$store.commit(
        'qaQuestionDetail/setAnswerList',
        page === 1 ? list : [...this.answerList, ...list]
      )
      return list
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .answer-item-outer.is-server {
  .yxl-more-outer-content {
    max-height: 270px !important;
    overflow: hidden;
  }
}
.qa-list {
  background-color: #fff;
  padding: 36px 0 0 0;
  box-sizing: border-box;
  .gray-line {
    width: 100%;
    height: 20px;
    background: #f8f9ff;
  }
  .normal-title {
    padding-left: 32px;
  }
  .answer-item-outer {
    padding: 32px;
    margin-bottom: 0;
    box-shadow: none;
    border-radius: 0;
  }
  .item-outer {
    box-sizing: border-box;
    &:last-child {
      padding-bottom: 0;
      .answer-item-outer {
        padding-bottom: 0;
      }
    }
  }
}
</style>
